export default __webpack_public_path__ + "static/media/5.3b6efc85.png";